var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg009Share(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426,340c-26.583,0-50.387,12.124-66.174,31.131l-66.919-33.283c-9.889-4.916-21.895-0.89-26.813,9.001 c-4.919,9.89-0.889,21.895,9.001,26.813l67.022,33.333C340.731,413.112,340,419.472,340,426c0,47.421,38.58,86,86,86 s86-38.579,86-86C512,378.579,473.42,340,426,340z M426,472c-25.364,0-46-20.636-46-46c0-6.29,1.269-12.288,3.565-17.754 c0.491-0.728,0.941-1.496,1.343-2.304c0.427-0.858,0.786-1.733,1.081-2.618C393.906,389.407,408.875,380,426,380 c25.364,0,46,20.636,46,46S451.364,472,426,472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,0c-47.42,0-86,38.579-86,86c0,6.627,0.754,13.081,2.179,19.281l-190.339,95.45C136.052,181.954,112.396,170,86,170 c-47.42,0-86,38.579-86,86s38.58,86,86,86c26.282,0,49.848-11.851,65.635-30.488l32.293,16.435c2.906,1.479,6.003,2.18,9.055,2.18 c7.286,0,14.31-3.995,17.841-10.933c5.01-9.845,1.092-21.886-8.753-26.896l-32.377-16.477C171.202,269.456,172,262.819,172,256 c0-6.709-0.772-13.241-2.233-19.511l190.241-95.401C375.796,159.97,399.52,172,426,172c47.42,0,86-38.579,86-86S473.42,0,426,0z  M86,302c-25.364,0-46-20.636-46-46s20.636-46,46-46s46,20.636,46,46S111.364,302,86,302z M426,132c-25.364,0-46-20.636-46-46 s20.636-46,46-46s46,20.636,46,46S451.364,132,426,132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg009Share);
export default __webpack_public_path__ + "static/media/009-share.a9459209699041912460094a0b560349.svg";
export { ForwardRef as ReactComponent };